<template>
    <pause-question :stageId="stageId" :question="question" :updateSubscriptionText="updateSubscriptionText" v-model="optionSelected" :errorMessage="errorHandler.get('plan')"/>
</template>

<script>
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import PauseQuestion from '@/components/partials/account/my-delivery-addresses/PauseQuestion';

let subscriptionService = new SubscriptionService();

export default {
    name: 'ReduceFrequencyStep',
    components: { PauseQuestion },
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        pauseSurveyAnswer: {
            type: Object,
            required: true,
        },
        plans: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isNextStepClicked: false,
            optionSelected: null,
            stageId: 'reduce-frequency',
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        subscriptionDetails() {
            return this.$store.getters['subscription/getSubscriptionById'](this.subscriptionId);
        },
        currentPlan() {
            return this.subscriptionDetails?.plan_slug;
        },
        newPlanOffer() {
            const currentPlanPosition = this.plans?.indexOf(this.currentPlan);
            const reducedPlan = this.plans[currentPlanPosition + 1];
            return reducedPlan;
        },
        question() {
            return this.$t('PAUSE_DELIVERIES_FREQ_QUESTION', { planFrequency: this.newPlanOffer });
        },
        updateSubscriptionText() {
            return this.$t('PAUSE_DELIVERIES_YES', { planFrequency: this.newPlanOffer });
        },
        updatedSteps() {
            const currentStepIndex = this.pauseSurveyAnswer.nextSteps.indexOf(this.stageId);
            return this.pauseSurveyAnswer.nextSteps.slice(currentStepIndex + 1);
        },
    },
    watch: {
        optionSelected() {
            if (this.optionSelected === 'update') {
                this.reduceFrequency();
            } else if (this.optionSelected === 'continue') {
                this.nextStep();
            }
        },
    },
    methods: {
        reduceFrequency() {
            subscriptionService.updateSubscriptionPlan(this.subscriptionId, this.newPlanOffer)
                .then(() => {
                    this.$emit('subscription-updated');
                })
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
        nextStep() {
            this.isNextStepClicked = true;
            this.$emit('input', this.updatedSteps);
        },
    },
};
</script>
